(() => {
  'use strict';

  const body = document.body;
  if (!body || body.dataset.plausibleEnabled !== 'true') return;

  const scriptSource = 'https://plausible.io/js/pa-Fk_nwGixc6V2ogpyvimyr.js';
  const existingLoader = document.querySelector('script[src*="plausible.io/js/"]');
  if (existingLoader || typeof window.plausible === 'function') return;

  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign'];
  const eventNames = {
    mochila_advertorial_cta_click: 'Advertorial CTA Click',
    mochila_advertorial_shelf_view: 'Advertorial Product Shelf View',
    mochila_advertorial_view: 'Advertorial View',
    mochila_artisan_story: 'Artisan Story',
    mochila_cart_add_success: 'Add to Cart',
    mochila_cart_drawer_open: 'Cart Open',
    mochila_category_navigation: 'Category Navigation',
    mochila_checkout_intent: 'Checkout Intent',
    mochila_collection_card_click: 'Product Click',
    mochila_gift_note_saved: 'Gift Note Saved',
    mochila_gift_wrap_add_success: 'Gift Wrap Added',
    mochila_pdp_gallery: 'Product Gallery',
    mochila_reviews_interaction: 'Reviews Interaction',
    mochila_search_submit: 'Search',
    mochila_second_bag_offer_accept: 'Second Bag Offer Accepted',
    mochila_second_bag_offer_applied: 'Second Bag Offer Applied',
    mochila_second_bag_offer_view: 'Second Bag Offer Viewed',
    mochila_size_guide: 'Size Guide',
    mochila_ui_error: 'Storefront Error'
  };

  const safeCampaignValue = (value) => {
    const candidate = String(value ?? '').trim().toLowerCase();
    return /^[a-z0-9_.-]{1,40}$/.test(candidate) ? candidate : '';
  };

  const safePageUrl = (value) => {
    try {
      const current = new URL(window.location.href);
      const source = new URL(value || current.href, current.origin);
      const pathname = source.origin === current.origin ? source.pathname : current.pathname;
      const safe = new URL(pathname, current.origin);

      campaignKeys.forEach((key) => {
        const campaignValue = safeCampaignValue(source.searchParams.get(key));
        if (campaignValue) safe.searchParams.set(key, campaignValue);
      });

      return safe.href;
    } catch (error) {
      return window.location.origin + window.location.pathname;
    }
  };

  const safeReferrer = (value) => {
    if (!value) return null;
    try {
      const source = new URL(value);
      if (source.protocol !== 'http:' && source.protocol !== 'https:') return null;
      return source.origin;
    } catch (error) {
      return null;
    }
  };

  const safeOutboundUrl = (value) => {
    if (!value) return null;
    try {
      const source = new URL(value, window.location.origin);
      if (source.protocol !== 'http:' && source.protocol !== 'https:') return null;
      return source.origin + source.pathname;
    } catch (error) {
      return null;
    }
  };

  const transformRequest = (payload = {}) => {
    payload.u = safePageUrl(payload.u);
    payload.r = safeReferrer(payload.r);

    if (payload.p && typeof payload.p === 'object' && 'url' in payload.p) {
      const outboundUrl = safeOutboundUrl(payload.p.url);
      payload.p = { ...payload.p };
      if (outboundUrl) {
        payload.p.url = outboundUrl;
      } else {
        delete payload.p.url;
      }
    }

    return payload;
  };

  window.plausible = function () {
    (window.plausible.q = window.plausible.q || []).push(arguments);
  };
  window.plausible.init = function (options) {
    window.plausible.o = options || {};
  };
  window.plausible.init({ transformRequest });

  const loader = document.createElement('script');
  loader.async = true;
  loader.src = scriptSource;
  loader.dataset.mochilaPlausible = 'true';
  document.head.appendChild(loader);

  const normalise = (value) => String(value ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100);

  const firstValue = (tags, keys) => {
    const value = keys.map((key) => tags[key]).find((candidate) => normalise(candidate));
    return normalise(value);
  };

  const safeProperties = (tags = {}) => {
    const properties = {
      action: firstValue(tags, ['mch_action', 'mch_operation']),
      method: firstValue(tags, ['mch_checkout_method', 'mch_gallery_method', 'mch_size_method']),
      product: firstValue(tags, ['mch_product_handle']),
      quantity: firstValue(tags, ['mch_quantity']),
      status: firstValue(tags, ['mch_status_bucket', 'mch_note_state']),
      surface: firstValue(tags, [
        'mch_checkout_surface',
        'mch_card_surface',
        'mch_review_surface',
        'mch_offer_surface',
        'mch_add_origin',
        'mch_component'
      ])
    };

    return Object.fromEntries(
      Object.entries(properties).filter(([, value]) => value)
    );
  };

  const track = (internalName, tags = {}) => {
    const eventName = eventNames[normalise(internalName)];
    if (!eventName || typeof window.plausible !== 'function') return false;

    const props = safeProperties(tags);
    const options = {
      interactive: internalName !== 'mochila_ui_error'
    };
    if (Object.keys(props).length) options.props = props;

    window.plausible(eventName, options);
    return true;
  };

  window.mochilaPlausible = Object.freeze({ track });
})();
